import { render, staticRenderFns } from "./Homeworks.vue?vue&type=template&id=6850a52e&scoped=true&lang=pug&"
import script from "./Homeworks.vue?vue&type=script&lang=js&"
export * from "./Homeworks.vue?vue&type=script&lang=js&"
import style0 from "./Homeworks.vue?vue&type=style&index=0&id=6850a52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6850a52e",
  null
  
)

export default component.exports